import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';

const HeadNews = ({ data }) => (
  <div className={styles.news}>
    <div className={styles.news_img}>
      <img src={data.imgSrc} alt={data.subtitle} />
    </div>
    <div className={styles.news_inner}>
      <div className={classnames('cr-sub', styles.news_date)}>
        <span>{data.date}</span>
      </div>
      <div>
        <p
          className={classnames(
            'cr-subheader-4 cr-text-3',
            styles.newstext_suptitle
          )}
        >
          {data.subtitle}
        </p>
        <p className={classnames('cr-h2 cr-white', styles.newstext_title)}>
          {data.title}
        </p>
      </div>
    </div>
  </div>
);

export default HeadNews;
